import type { Control } from 'react-hook-form';
import { Controller } from 'src/components/form/field-controller/Controller';
import type { Content } from 'src/components/help-panel/useHelpStore';
import type { IssueAssessmentFields } from 'src/pages/issues/update/forms/issue-assessment-form/issueAssessmentSchema';

import { ResponsibleThirdPartyAutosuggestView } from './ResponsibleThirdPartyAutosuggestView';
import { useResponsibleThirdPartyAutosuggest } from './useResponsibleThirdPartyAutosuggest';

export interface ResponsibleThirdPartyAutosuggestProps {
  control: Control<IssueAssessmentFields>;
  description?: Content;
  disabled?: boolean;
  label: string;
  name: 'ThirdPartyResponsible';
  placeholder?: string;
  shouldSkip: boolean;
  testId?: string;
}

export const ResponsibleThirdPartyAutosuggest = ({
  control,
  description,
  disabled,
  label,
  name,
  placeholder,
  shouldSkip,
  testId,
}: ResponsibleThirdPartyAutosuggestProps) => {
  const { props } = useResponsibleThirdPartyAutosuggest({
    control,
    disabled,
    name,
    shouldSkip,
  });

  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <ResponsibleThirdPartyAutosuggestView
          {...props}
          field={field}
          guidance={description}
          label={label}
          placeholder={placeholder}
          testId={testId}
        />
      )}
    />
  );
};
